import { Product } from '../../products/types/product.type';
import { Basket } from '../../baskets/types/basket.type';
import { OrderItem } from '../types/order-item.type';

export function formatProductToOrderItem(product: Product): OrderItem {
  return {
    type: product.type,
    name: product.name,
    ref: product.reference,
    category: product.category.name,
    subcategory: product.subCategory.name,
    size: product.size,
    price: product.price,
    tvaRate: product.tvaRate,
    quantity: 1,
    noLabel: false,
    valueZero: false,
    productId: product.id,
    photo: product.photo ?? undefined,
  };
}

export function formatBasketToOrderItem(basket: Basket): OrderItem {
  return {
    type: 'basket',
    name: basket.name,
    ref: basket.reference,
    category: basket.category.name,
    subcategory: basket.subCategory.name,
    size: basket.size,
    price: basket.price,
    tvaRate: basket.tvaRate,
    quantity: 1,
    noLabel: false,
    valueZero: false,
    productId: basket.id,
    photo: basket.photo,
  };
}
